/**
 * MyAttendance — ประวัติการเข้างานของพนักงาน (TASK 24b).
 * Range picker → stat cards → day-by-day timeline (shared AttendanceTimeline).
 */
import { useState } from 'react';
import { PageLayout } from '../components/layout/PageLayout';
import { useMyAttendance } from '../hooks';
import {
  AttendanceTimeline,
  AttendanceRangePresets,
  rangeForPreset,
  thisMonthRange,
  type RangePreset,
} from '../components/domain/AttendanceTimeline';

export function MyAttendance() {
  const [range, setRange] = useState(thisMonthRange);
  const [preset, setPreset] = useState<RangePreset>('this-month');
  const { data, isLoading } = useMyAttendance(range);

  function applyPreset(p: RangePreset) {
    setPreset(p);
    setRange(rangeForPreset(p));
  }

  return (
    <PageLayout title="ประวัติการเข้างาน">
      <AttendanceRangePresets preset={preset} onChange={applyPreset} />
      <AttendanceTimeline data={data} isLoading={isLoading} />
    </PageLayout>
  );
}
